// extracted by mini-css-extract-plugin
export default {"page":"styles_page__F9gaQ","content":"styles_content__mUKoE"};